import { createFileRoute, redirect } from '@tanstack/react-router';
import { ProjectsHead } from '@/features/projects/ui/ProjectsHead';
import { SheetTabPage } from '@/features/sync/SheetTabPage';
import { SHEET_TABS } from '@/features/sync/sheetTabConfigs';
import { legacyCompareRedirect, syncSearchSchema } from '@/features/sync/syncSearch';

export const Route = createFileRoute('/_authenticated/projects/sheet')({
  validateSearch: syncSearchSchema,
  beforeLoad: ({ search }) => {
    if (legacyCompareRedirect(search, '/projects/review')) throw redirect({ to: '/projects/review', search: { f: search.f, s: search.s }, replace: true });
  },
  component: function ProjectsSheet() {
    const navigate = Route.useNavigate();
    return (
      <div className="flex flex-col gap-4">
        <ProjectsHead />
        <SheetTabPage config={SHEET_TABS.projects} onScanned={() => void navigate({ to: '/projects/review' })} />
      </div>
    );
  },
});
